// @flow

import type { ConfigBuilder, ConfigHeaders } from './types';
import type { State } from '../types';

type GlobalState = {
  configuration: State,
};

export const getConfigBuilder = (state: GlobalState): ConfigBuilder => (
  state.configuration.configBuilder
);

export const getConfigHeaders = (state: GlobalState): ConfigHeaders => (
  getConfigBuilder(state)
    .map(item => {
      const {
        elements,
        ...allItemPropsWithoutElements
      } = item;

      return allItemPropsWithoutElements;
    })
);
